import TEMPLATE_URL from "emun.order/order-manual-split.htm";
import controller from "emun.order/order-manual-split.controller";
import open from "webmodals/open";

export default ({
	size = "xl",
	backdrop = "static",
	placement = "center",
	templateUrl = TEMPLATE_URL,
	mode = "multi-add",
	imageSize = "xxs",
	criteria = {},
	title = `Split Order...`,
	subTitle
}) =>
	open({
		size,
		backdrop,
		templateUrl,
		placement,
		controller,
		bindToController: true,
		controllerAs: "$ctrl",
		resolve: {
			title: () => title,
			subTitle: () => subTitle,
			mode: () => mode,
			imageSize: () => imageSize,
			criteria: () => criteria
		}
	}).result;
